import type { Studio, StudioId } from '@/domain/types';

// 11 studios with branded AU numbers, locations, and operating hours.
// PRD §7 (network scale) and §6 (assignment model).

const std = (open: string, close: string) => ({ open, close });
const closedDay = null;

export const STUDIOS: Record<StudioId, Studio> = {
  coburg: {
    id: 'coburg',
    name: 'Coburg',
    brandedNumber: '+61 3 9024 1100',
    state: 'VIC',
    address: '512 Sydney Rd, Coburg',
    postcode: '3058',
    lat: -37.7437,
    lon: 144.9648,
    artistCount: 18,
    assignedAgentIds: ['agent-lydia', 'agent-cameron'],
    operatingHours: {
      mon: std('10:00', '20:00'),
      tue: std('10:00', '20:00'),
      wed: std('10:00', '20:00'),
      thu: std('10:00', '21:00'),
      fri: std('10:00', '21:00'),
      sat: std('10:00', '20:00'),
      sun: std('11:00', '18:00'),
    },
    managerId: 'mgr-coburg',
    isBlackBook: false,
    brand: 'Addikted to Ink',
  },
  collingwood: {
    id: 'collingwood',
    name: 'Collingwood',
    brandedNumber: '+61 3 9024 1200',
    state: 'VIC',
    address: '45 Smith St, Collingwood',
    postcode: '3066',
    lat: -37.8006,
    lon: 144.9880,
    artistCount: 3,
    assignedAgentIds: ['agent-lydia', 'agent-cameron'],
    operatingHours: {
      mon: std('10:00', '20:00'),
      tue: std('10:00', '20:00'),
      wed: std('10:00', '20:00'),
      thu: std('10:00', '21:00'),
      fri: std('10:00', '21:00'),
      sat: std('10:00', '20:00'),
      sun: closedDay,
    },
    managerId: 'mgr-collingwood',
    isBlackBook: false,
    brand: 'Addikted to Ink',
  },
  frankston: {
    id: 'frankston',
    name: 'Frankston',
    brandedNumber: '+61 3 9024 1300',
    state: 'VIC',
    address: '74 Wells St, Frankston',
    postcode: '3199',
    lat: -38.1404,
    lon: 145.1226,
    artistCount: 3,
    assignedAgentIds: ['agent-jordan'],
    operatingHours: {
      mon: std('10:00', '19:00'),
      tue: std('10:00', '19:00'),
      wed: std('10:00', '19:00'),
      thu: std('10:00', '20:00'),
      fri: std('10:00', '20:00'),
      sat: std('10:00', '18:00'),
      sun: closedDay,
    },
    managerId: 'mgr-frankston',
    isBlackBook: false,
    brand: 'Addikted to Ink',
  },
  windsor: {
    id: 'windsor',
    name: 'Windsor',
    brandedNumber: '+61 3 9024 1400',
    state: 'VIC',
    address: '112 Chapel St, Windsor',
    postcode: '3181',
    lat: -37.8560,
    lon: 144.9926,
    artistCount: 5,
    assignedAgentIds: ['agent-jordan'],
    operatingHours: {
      mon: std('10:00', '19:00'),
      tue: std('10:00', '19:00'),
      wed: std('10:00', '19:00'),
      thu: std('10:00', '20:00'),
      fri: std('10:00', '20:00'),
      sat: std('10:00', '18:00'),
      sun: closedDay,
    },
    managerId: 'mgr-windsor',
    isBlackBook: false,
    brand: 'Melburn Made Ink',
  },
  'central-coast': {
    id: 'central-coast',
    name: 'Central Coast',
    brandedNumber: '+61 2 9024 1500',
    state: 'NSW',
    address: '102 Mann St, Gosford',
    postcode: '2250',
    lat: -33.4253,
    lon: 151.3431,
    artistCount: 5,
    assignedAgentIds: ['agent-priya'],
    operatingHours: {
      mon: std('10:00', '19:00'),
      tue: std('10:00', '19:00'),
      wed: std('10:00', '19:00'),
      thu: std('10:00', '20:00'),
      fri: std('10:00', '20:00'),
      sat: std('10:00', '18:00'),
      sun: closedDay,
    },
    managerId: 'mgr-central-coast',
    isBlackBook: false,
    brand: 'Inked Gallery',
  },
  'emu-plains': {
    id: 'emu-plains',
    name: 'Emu Plains',
    brandedNumber: '+61 2 9024 1600',
    state: 'NSW',
    address: '5 Great Western Hwy, Emu Plains',
    postcode: '2750',
    lat: -33.7490,
    lon: 150.6670,
    artistCount: 3,
    assignedAgentIds: ['agent-priya'],
    operatingHours: {
      mon: std('10:00', '19:00'),
      tue: std('10:00', '19:00'),
      wed: std('10:00', '19:00'),
      thu: std('10:00', '20:00'),
      fri: std('10:00', '20:00'),
      sat: std('10:00', '18:00'),
      sun: closedDay,
    },
    managerId: 'mgr-emu-plains',
    isBlackBook: true,
    brand: 'Black Book Tattoo',
  },
  liverpool: {
    id: 'liverpool',
    name: 'Liverpool',
    brandedNumber: '+61 2 9024 1800',
    state: 'NSW',
    address: '180 George St, Liverpool',
    postcode: '2170',
    lat: -33.9203,
    lon: 150.9237,
    artistCount: 5,
    assignedAgentIds: ['agent-priya'],
    operatingHours: {
      mon: std('10:00', '20:00'),
      tue: std('10:00', '20:00'),
      wed: std('10:00', '20:00'),
      thu: std('10:00', '21:00'),
      fri: std('10:00', '21:00'),
      sat: std('10:00', '19:00'),
      sun: closedDay,
    },
    managerId: 'mgr-liverpool',
    isBlackBook: true,
    brand: 'Black Book Tattoo',
  },
  brisbane: {
    id: 'brisbane',
    name: 'Brisbane',
    brandedNumber: '+61 7 9024 1900',
    state: 'QLD',
    address: '142 Brunswick St, Fortitude Valley',
    postcode: '4006',
    lat: -27.4561,
    lon: 153.0357,
    artistCount: 3,
    assignedAgentIds: ['agent-malia'],
    operatingHours: {
      mon: std('10:00', '20:00'),
      tue: std('10:00', '20:00'),
      wed: std('10:00', '20:00'),
      thu: std('10:00', '21:00'),
      fri: std('10:00', '21:00'),
      sat: std('10:00', '19:00'),
      sun: std('11:00', '17:00'),
    },
    managerId: 'mgr-brisbane',
    isBlackBook: false,
    brand: 'Blood Money Tattoo',
  },
  'gold-coast': {
    id: 'gold-coast',
    name: 'Gold Coast',
    brandedNumber: '+61 7 9024 2000',
    state: 'QLD',
    address: '24 Hooker Blvd, Broadbeach',
    postcode: '4218',
    lat: -28.0335,
    lon: 153.4321,
    artistCount: 5,
    assignedAgentIds: ['agent-malia'],
    operatingHours: {
      mon: std('10:00', '20:00'),
      tue: std('10:00', '20:00'),
      wed: std('10:00', '20:00'),
      thu: std('10:00', '21:00'),
      fri: std('10:00', '21:00'),
      sat: std('10:00', '19:00'),
      sun: closedDay,
    },
    managerId: 'mgr-gold-coast',
    isBlackBook: false,
    brand: 'Blood Money Tattoo',
  },
  mackay: {
    id: 'mackay',
    name: 'Mackay',
    brandedNumber: '+61 7 9024 1700',
    state: 'QLD',
    address: '45 Victoria St, Mackay',
    postcode: '4740',
    lat: -21.1416,
    lon: 149.1860,
    artistCount: 5,
    assignedAgentIds: ['agent-priya'],
    operatingHours: {
      mon: std('10:00', '21:00'),
      tue: std('10:00', '21:00'),
      wed: std('10:00', '21:00'),
      thu: std('10:00', '22:00'),
      fri: std('10:00', '22:00'),
      sat: std('10:00', '21:00'),
      sun: std('11:00', '18:00'),
    },
    managerId: 'mgr-mackay',
    isBlackBook: false,
    brand: 'Full House Tattoo',
  },
  tasmania: {
    id: 'tasmania',
    name: 'Hobart',
    brandedNumber: '+61 3 9024 2100',
    state: 'TAS',
    address: '80 Elizabeth St, Hobart',
    postcode: '7000',
    lat: -42.8826,
    lon: 147.3257,
    artistCount: 5,
    assignedAgentIds: ['agent-rachel'],
    operatingHours: {
      mon: std('10:00', '19:00'),
      tue: std('10:00', '19:00'),
      wed: std('10:00', '19:00'),
      thu: std('10:00', '21:00'),
      fri: std('10:00', '21:00'),
      sat: std('10:00', '19:00'),
      sun: closedDay,
    },
    managerId: 'mgr-tasmania',
    isBlackBook: false,
    brand: 'Branded Hide',
  },
};

// Per-studio practical info. Drives the confirmation SMS templates and the
// Settings → Studios admin tab. Text is verbatim what the agent would write —
// short, plain, local.
const GETTING_HERE: Partial<Record<StudioId, NonNullable<Studio['gettingHere']>>> = {
  coburg: {
    parking: '2hr free parking on Reynard St (1 block over). Sydney Rd ticketed only.',
    transport: 'Tram 19 stops right outside (Bell St stop). Coburg station is a 4-min walk.',
    directions: 'Big black-on-gold sign, opposite the bakery. Buzz at the door if it\'s after 7pm.',
  },
  collingwood: {
    parking: 'Smith St is metered. Free 2hr on Peel St + the side streets off Wellington.',
    transport: 'Tram 86 stops outside (Smith St / Perry St). Collingwood station is a 6-min walk.',
    directions: 'Above the vintage store. Stairs on the left, push the buzzer for floor 2.',
  },
  frankston: {
    parking: 'Free 2hr parking in the Wells St mall carpark right next door.',
    transport: 'Frankston station is a 5-min walk. Bus 770/776/779 stops nearby.',
    directions: 'Ground floor, next to the cafe with the green awning.',
  },
  windsor: {
    parking: 'Chapel St is metered. Free 2hr on Green St + the streets behind the strip.',
    transport: 'Tram 78 runs down Chapel St. Windsor station is a 3-min walk.',
    directions: 'Black shopfront with the gold lettering, near the Dandenong Rd end. Hard to miss.',
  },
  'central-coast': {
    parking: 'Imperial Centre carpark (2hr free) is a 1-min walk.',
    transport: 'Gosford station is a 4-min walk down Mann St.',
    directions: 'Look for the awning over the entrance. Reception is straight ahead.',
  },
  'emu-plains': {
    parking: 'Free 2hr in the Lennox Centre carpark. Great Western Hwy is ticketed only.',
    transport: 'Emu Plains station is a 6-min walk. Blue Mountains line stops nearby.',
    directions: 'Discreet black door. Black Book signage only on the buzzer panel.',
  },
  liverpool: {
    parking: 'Westfield Liverpool has 3hr free parking. 4-min walk down George St.',
    transport: 'Liverpool station is a 5-min walk. Buses stop on Macquarie St.',
    directions: 'Discreet black door. Black Book signage only on the buzzer panel.',
  },
  mackay: {
    parking: 'Free 2hr on Victoria St + the Sydney St carpark, 3-min walk.',
    transport: 'City centre buses stop on Sydney St. Easy walk from the river precinct.',
    directions: 'Glass front on Victoria St, between the cafe and the surf shop.',
  },
  brisbane: {
    parking: 'Wickham St ticketed. Free 2hr on James St side streets.',
    transport: 'Fortitude Valley station is a 6-min walk. Bus 196/199 nearby.',
    directions: 'Above the bar with the neon sign. Side entrance on Brunswick.',
  },
  'gold-coast': {
    parking: 'Free 3hr at Oasis Shopping Centre carpark, 2-min walk.',
    transport: 'Tram (G:link) Broadbeach North or Broadbeach South — 4-min walk either way.',
    directions: 'Discreet entrance on Hooker Blvd. Press the buzzer for Black Book.',
  },
  tasmania: {
    parking: 'Free 1hr on Elizabeth St. Argyle St carpark ($12 flat evenings), 3-min walk.',
    transport: 'City centre buses stop on Elizabeth St. Easy walk from the Hobart waterfront.',
    directions: 'Heritage building, big timber door. Reception is up the half-staircase.',
  },
};

const PREP_NOTES: Partial<Record<StudioId, NonNullable<Studio['prepNotes']>>> = {
  coburg: { eatBeforehand: true, hydrate: true, custom: 'Bring snacks for sessions over 4 hours.' },
  collingwood: { eatBeforehand: true, hydrate: true },
  frankston: { eatBeforehand: true, hydrate: true },
  windsor: { eatBeforehand: true, hydrate: true },
  'central-coast': { eatBeforehand: true, hydrate: true, custom: 'Bring a jumper — the studio is air-conditioned.' },
  'emu-plains': { eatBeforehand: true, hydrate: true },
  liverpool: { eatBeforehand: true, hydrate: true, custom: 'Studio runs late — fine to come straight from work.' },
  brisbane: { eatBeforehand: true, hydrate: true, custom: 'Wear loose clothing — Brisbane summer in the studio gets warm.' },
  'gold-coast': { eatBeforehand: true, hydrate: true, custom: 'Avoid sun the day before — sunburn delays sessions.' },
  mackay: { eatBeforehand: true, hydrate: true, custom: 'Wear loose clothing. The tropics get warm in the studio.' },
  tasmania: { eatBeforehand: true, hydrate: true },
};

// Merge the practical info into the exported STUDIOS map so consumers see one
// integrated record per location.
for (const id of Object.keys(STUDIOS) as StudioId[]) {
  STUDIOS[id].gettingHere = GETTING_HERE[id];
  STUDIOS[id].prepNotes = PREP_NOTES[id];
}

export const STUDIO_IDS = Object.keys(STUDIOS) as StudioId[];
